package one.healthium.featureconfig.domain

data class ConfigKey<T>(
    val name: String,
    val defaultValue: T,
    val type: ConfigType<T>,
) {
    companion object {
        fun boolean(name: String, defaultValue: Boolean) = ConfigKey(
            name = name,
            defaultValue = defaultValue,
            type = ConfigType.Boolean,
        )

        fun string(name: String, defaultValue: String) = ConfigKey(
            name = name,
            defaultValue = defaultValue,
            type = ConfigType.String,
        )

        fun long(name: String, defaultValue: Long) = ConfigKey(
            name = name,
            defaultValue = defaultValue,
            type = ConfigType.Long,
        )

        fun double(name: String, defaultValue: Double) = ConfigKey(
            name = name,
            defaultValue = defaultValue,
            type = ConfigType.Double,
        )
    }
}
